import { useToast } from "@chakra-ui/react";

import { useOnlyOnce } from "@nens/react/hooks";

import { isTestEnvironment } from "@/utils/is-test-environment";

const UNEXPECTED_PUBLICATION_STATE_WARNING = `Publication data is undefined despite having been loaded previously. This means a fetch is being triggered after the publication data was updated in React state, rather than before.\n
This will cause a loading state to appear in the UI and any unsaved changes to be discarded — which should not happen.\n
Please investigate.`;
const UNEXPECTED_PUBLICATION_STATE_WARNING_TEST =
  UNEXPECTED_PUBLICATION_STATE_WARNING +
  `\n
(This warning only appears in test environments, but it indicates a bug that can cause data loss. Please submit a ticket if you encounter this.)`;

export const UnexpectedPublicationStateWarning = () => {
  const toast = useToast();
  useOnlyOnce(() => {
    console.warn(UNEXPECTED_PUBLICATION_STATE_WARNING);
    if (isTestEnvironment())
      toast({
        title: "Unexpected publication state",
        description: UNEXPECTED_PUBLICATION_STATE_WARNING_TEST.split("\n").map((line, index) => (
          <span key={index}>
            {line}
            <br />
          </span>
        )),
        status: "warning",
        isClosable: true,
        duration: 60_000,
      });
  });
  return null;
};
